import React, {
  FC,
  useState,
  useEffect,
  useCallback,
  ComponentProps,
} from 'react'
import NumericStepper from '@vtex/styleguide/lib/NumericStepper'
import debounce from 'lodash/debounce'
import { useProductContext } from '../context'
import { getItemPayload } from '@/checkout-instore-legacy/utils/ProductUtils'
import { ItemPayload } from '@/checkout-instore-legacy/cart/message/types'
import { getActualQuantity } from '../utils'

export interface NumericProps {
  changeItemQuantity: (item: ItemPayload) => void
  numericStepperProps?: ComponentProps<typeof NumericStepper>
}

interface NumericStepperChangeEvent {
  value: number
  stopPropagation: () => void
}

const DEFAULT_DEBOUNCE_TIME = 300

const Numeric: FC<NumericProps> = ({
  changeItemQuantity,
  numericStepperProps,
}) => {
  const { item } = useProductContext()
  const [quantity, setQuantity] = useState<number>(0)
  const itemPayload = getItemPayload(item)

  const handleUpdateQuantity = (value: number) => {
    const increment = value - item.quantity
    const actualQuantity = getActualQuantity(item) ?? 0
    const actualValue = actualQuantity + increment

    const updated = {
      ...itemPayload,
      quantity: actualValue,
    }
    setQuantity(value)
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ quantity: number; id: string; ... Remove this comment to see the full error message
    changeItemDebounced(updated)
  }

  useEffect(() => {
    setQuantity(item.quantity)
  }, [item.quantity])

  const changeItemDebounced = useCallback(
    debounce((item: ItemPayload) => {
      changeItemQuantity(item)
    }, DEFAULT_DEBOUNCE_TIME),
    []
  )

  return (
    <div data-cy="cart-item-numeric-stepper" className="w4">
      <NumericStepper
        lean
        block
        value={quantity || item.quantity}
        minValue={1}
        onChange={(event: NumericStepperChangeEvent) => {
          handleUpdateQuantity(event.value)
        }}
        size="small"
        {...numericStepperProps}
      />
    </div>
  )
}

export default Numeric
